var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"append-icon":_vm.searchIcon,"clearable":"","placeholder":"Search"},on:{"input":_vm.debounceChange},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})}
var staticRenderFns = []

export { render, staticRenderFns }